import Joi from 'joi';
import {
  COMMENT_MAX_LENGTH,
  COMMENT_MIN_LENGTH
} from '../constants/reappraisalRationaleReviewConstants';

const ReappraisalRationalReviewInputValidator = {
  validateInput: input => {
    const schema = Joi.object({
      comment: Joi.string().min(COMMENT_MIN_LENGTH).max(COMMENT_MAX_LENGTH).required()
    });
    return schema.validate(input);
  }
};

export default ReappraisalRationalReviewInputValidator;
